/* 変更依頼 */
import React, { useState } from 'react';
import ShelfInShelf from '../molecules/ShelfInShelf';
import TextArea from '../molecules/TextArea';

interface Props {
  change_request_message: string;
}

const ChangeRequest: React.FC<Props> = ({ change_request_message }) => {
  const [show_shelf, setShowShelf] = useState(true);
  const toggleShowShelf = () => setShowShelf(prev => !prev);

  return (
    <ShelfInShelf
      id="change-request"
      is_open={show_shelf}
      handleClick={toggleShowShelf}
      label="変更依頼"
    >
      <TextArea
        label="お客様へのお知らせ"
        name="change-request-text"
        id="change-request-text"
        handleChange={() => {}}
        value={change_request_message}
        placeholder={''}
        maxlength={5}
        disabled={false}
        looks_inactive={true}
      />
    </ShelfInShelf>
  );
};
export default ChangeRequest;
